import {
  CREATE_COURSE_FAILURE,
  CREATE_COURSE_REQUEST,
  CREATE_COURSE_SUCCESS,
  FETCH_CREATED_COURSES_FAILURE,
  FETCH_CREATED_COURSES_REQUEST,
  FETCH_CREATED_COURSES_SUCCESS,
  UPDATE_COURSE_FAILURE,
  UPDATE_COURSE_SUCCESS,
  CLEAR_CREATE_COURSE_STATE,
} from "../Actions/courseCreateActions";

const initialState = {
  loading: false,
  success: false,
  error: null,
  course: null, // Storing the created course data

  message: null, // Store the message
  createdCourses: [], // Store the list of created courses
};

const createCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COURSE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
        message: null,
      };
    case CREATE_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        course: action.payload.course || null,
        message: action.payload.message || "Course created successfully!", // Message from backend
        error: null,
      };
    case CREATE_COURSE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        course: null, // Reset the course on failure
        message: action.payload.message || "Error creating course!",
        error: action.payload.message || "Error creating course!",
      };
    case UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        course: action.payload.course || null,
        message: action.payload.message || "Course updated successfully!", // Message from backend
        error: null,
      };
    case UPDATE_COURSE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        course: null, // Reset the course on failure
        message: action.payload.message || "Error updating course!",
        error: action.payload.message || "Error updating course!",
      };
    case FETCH_CREATED_COURSES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CREATED_COURSES_SUCCESS:
      return {
        ...state,
        loading: false,
        createdCourses: action.payload,
        error: null,
      };
    case FETCH_CREATED_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        createdCourses: [],
      };
    case CLEAR_CREATE_COURSE_STATE:
      return {
        ...state,
        success: false,
        error: null,
        message: null,
        course: null,
      };
    default:
      return state;
  }
};

export default createCourseReducer;

